import React from 'react';
import { motion } from 'framer-motion';

const Terms = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="pt-16 lg:pt-20"
    >
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-blue-900 to-blue-700 dark:from-blue-950 dark:to-blue-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            className="text-center text-white"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Conditions d'Utilisation
            </h1>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-20 bg-white dark:bg-gray-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            className="space-y-8 text-gray-700 dark:text-gray-300"
          >
            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                1. Acceptation des Conditions
              </h2>
              <p className="mb-4">
                En accédant et en utilisant ce site web, vous acceptez d'être lié par ces conditions d'utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser ce site.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                2. Utilisation Autorisée
              </h2>
              <p className="mb-4">
                Vous acceptez d'utiliser ce site uniquement à des fins légales et en conformité avec toutes les lois applicables. Vous ne devez pas :
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Utiliser le site de manière qui pourrait l'endommager ou le rendre indisponible</li>
                <li>Tenter d'accéder sans autorisation à nos systèmes ou données</li>
                <li>Télécharger ou transmettre des virus ou contenus malveillants</li>
                <li>Utiliser le site pour du harcèlement ou du spam</li>
                <li>Violer la propriété intellectuelle d'autrui</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                3. Contenu Utilisateur
              </h2>
              <p className="mb-4">
                Tout contenu que vous soumettez via ce site (formulaires de contact, commentaires, etc.) doit être exact, légal et ne doit pas violer les droits d'autrui. M.A.M Consulting se réserve le droit de supprimer tout contenu inapproprié.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                4. Disclaimers
              </h2>
              <p className="mb-4">
                Ce site et ses contenus sont fournis "tels quels" sans garantie d'aucune sorte. M.A.M Consulting ne garantit pas :
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>L'exactitude ou l'exhaustivité des informations</li>
                <li>L'absence d'erreurs ou d'omissions</li>
                <li>La disponibilité continue du site</li>
                <li>L'absence de virus ou de contenus nuisibles</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                5. Limitation de Responsabilité
              </h2>
              <p className="mb-4">
                En aucun cas, M.A.M Consulting ne sera responsable des dommages directs, indirects, accessoires, spéciaux ou consécutifs résultant de :
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>L'utilisation ou l'impossibilité d'utiliser ce site</li>
                <li>Le contenu ou les services fournis</li>
                <li>Les erreurs ou omissions</li>
                <li>L'interruption du service</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                6. Liens Externes
              </h2>
              <p className="mb-4">
                Ce site peut contenir des liens vers des sites externes. M.A.M Consulting n'est pas responsable du contenu, de la disponibilité ou de la conformité légale de ces sites tiers. Les liens sont fournis à titre informatif uniquement.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                7. Propriété Intellectuelle
              </h2>
              <p className="mb-4">
                Tous les contenus du site (textes, images, logos, etc.) sont la propriété de M.A.M Consulting ou de ses partenaires et sont protégés par les lois sur la propriété intellectuelle. Toute reproduction sans autorisation est interdite.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                8. Modification des Conditions
              </h2>
              <p className="mb-4">
                M.A.M Consulting se réserve le droit de modifier ces conditions d'utilisation à tout moment. Les modifications prendront effet immédiatement après leur publication. Votre utilisation continue du site implique votre acceptation des conditions modifiées.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                9. Résiliation
              </h2>
              <p className="mb-4">
                M.A.M Consulting se réserve le droit de refuser l'accès au site à tout utilisateur qui violerait ces conditions d'utilisation.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                10. Droit Applicable
              </h2>
              <p className="mb-4">
                Ces conditions d'utilisation sont régies par la loi camerounaise. Tout litige sera soumis à la juridiction compétente du Cameroun.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                11. Contact
              </h2>
              <p className="mb-4">
                Pour toute question concernant ces conditions d'utilisation, veuillez nous contacter :
              </p>
              <p className="mb-2">
                <strong>Email :</strong> contact@mam-consulting.biz
              </p>
              <p>
                <strong>Téléphone :</strong> +237 699 187 929
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </motion.div>
  );
};

export default Terms;